import {
    TABS_ADD_TAB,
    TABS_ADD_TAB_FROM_OLD,
    TABS_REMOVE_TAB,
    TABS_REMOVE_TAB_FROM_OLD,
    TABS_ACTIVE_TAB,
    TABS_SET_TAB_TEXT,
    TABS_NEW_TAB_ADDED,
    TABS_TAB_REMOVED,
    TABS_TAB_ACTIVATED,
    TAB_ACTIVATE_ON_CLICK,
} from './constants'

export function addTab(id, type, text) {
    return {
        type: TABS_ADD_TAB,
        data: {
            id,
            type,
            text,
        },
    }
}

export function tabsAddTabFromOld(id, type, text) {
    return {
        type: TABS_ADD_TAB_FROM_OLD,
        data: {
            id,
            type,
            text,
        },
    }
}

export function removeTab(id, type) {
    return {
        type: TABS_REMOVE_TAB,
        data: {
            id,
            type,
        },
    }
}

export function removeTabFromOld(id, type) {
    return {
        type: TABS_REMOVE_TAB_FROM_OLD,
        data: {
            id,
            type,
        },
    }
}

export function activeTab(id, type) {
    return {
        type: TABS_ACTIVE_TAB,
        data: {
            id,
            type,
        },
    }
}

export function setTabText(id, type, text) {
    return {
        type: TABS_SET_TAB_TEXT,
        data: {
            id,
            type,
            text,
        },
    }
}

export function newTabAdded(id, type) {
    return {
        type: TABS_NEW_TAB_ADDED,
        data: {
            id,
            type,
        },
    }
}

export function tabRemoved(id, type) {
    return {
        type: TABS_TAB_REMOVED,
        data: {
            id,
            type,
        },
    }
}

export function tabActivated(id, type) {
    return {
        type: TABS_TAB_ACTIVATED,
        data: {
            id,
            type,
        },
    }
}

export function tabActivateOnClick(id, type) {
    return {
        type: TAB_ACTIVATE_ON_CLICK,
        data: {
            id,
            type,
        },
    }
}
